import React, { FC, ReactElement } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useFormContext, Controller } from 'react-hook-form';

import { IdeaUpdateFormValues } from 'buyside/components/presentation/IdeaShowPage/AuthorActions/ideaUpdateForm';

import { withThesisImageConfig } from 'buyside/util/tinymceConfig';

import styles from '../authorActionsStyles.scss';

const IdeaUpdateForm: FC<{ date: string }> = ({ date }): ReactElement => {
  const {
    control,
    formState: { isSubmitting }
  } = useFormContext<IdeaUpdateFormValues>();

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeader}>
        <strong>Enter the details of your update for {date}</strong>
        <span> (Optional)</span>
      </div>
      <Controller
        control={control}
        name="body"
        render={({ field: { ref, value, onChange } }): ReactElement => (
          <Editor
            disabled={isSubmitting}
            init={withThesisImageConfig()}
            onEditorChange={(value): void => onChange(value)}
            ref={ref}
            value={value || ''}
          />
        )}
      />
    </div>
  );
};

export default IdeaUpdateForm;
